import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"

const Container = styled(Link)`
  padding: 8px 16px;
  background-color: ${props => props.theme.primary};
  /* box-shadow: 4px 4px 0px #ffa4ac; */
  color: ${props => props.theme.shade[100]};
  text-decoration: none;
  transition: 0.2s;
  border-radius: 4px;
  &:hover {
    background-color: ${props => props.theme.primary + "cc"};
  }
`

export default function Button(props) {
  return <Container to={props.to}>{props.children}</Container>
}
